var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5438 3.11797H14.3813C14.3688 2.78047 14.0938 2.51172 13.7563 2.51172C13.4125 2.51172 13.1438 2.78047 13.1313 3.11797H10.625C10.6206 2.95533 10.5527 2.80085 10.436 2.68757C10.3192 2.57428 10.1627 2.51117 10 2.51172C9.6625 2.51172 9.3875 2.78047 9.375 3.11797H6.875C6.8625 2.78047 6.5875 2.51172 6.25 2.51172C5.9125 2.51172 5.6375 2.78047 5.625 3.11797H4.4625C3.38125 3.11797 2.5 3.99297 2.5 5.07422V15.5242C2.5 16.6055 3.38125 17.4867 4.4625 17.4867H15.5438C16.625 17.4867 17.5 16.6055 17.5 15.5242V5.07422C17.5 3.99297 16.625 3.11797 15.5438 3.11797ZM16.25 15.5242C16.25 15.918 15.9313 16.2367 15.5438 16.2367H4.4625C4.06875 16.2367 3.75 15.918 3.75 15.5242V6.86172H16.25V15.5242ZM16.25 5.61172H3.75V5.07422C3.75 4.68047 4.06875 4.36797 4.4625 4.36797H5.625V4.38672C5.625 4.73047 5.90625 5.01172 6.25 5.01172C6.59375 5.01172 6.875 4.73047 6.875 4.38672V4.36797H9.375V4.38672C9.375 4.73047 9.65625 5.01172 10 5.01172C10.35 5.01172 10.625 4.73047 10.625 4.38672V4.36797H13.1313V4.38672C13.1313 4.73047 13.4062 5.01172 13.7563 5.01172C14.1 5.01172 14.3813 4.73047 14.3813 4.38672V4.36797H15.5438C15.9313 4.36797 16.25 4.68047 16.25 5.07422V5.61172Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.ae0446154e3a7ef22a2fae19d3f57652.svg";
export { ForwardRef as ReactComponent };